"use client";
import { defaultLocale } from "@/config";
import { Tabs } from "antd";
import { StyledArticle } from "../Blogs/BlogArticle";
import { useTranslations } from "next-intl";
import { replaceImgUrl } from "@/lib/utils.ts";

const ProductDescription = ({ product, locale }) => {
	const t = useTranslations();
	return (
		<div className="border">
			<Tabs
				type="card"
				className="product_desc"
				items={new Array(1).fill(null).map((_, i) => {
					const id = String(i + 1);
					return {
						label: t("product.product-description"),
						key: id,
						children: (
							<StyledArticle>
								<div
									className="p-4"
									dangerouslySetInnerHTML={{
										__html:
											locale === defaultLocale
												? filterSortDsc(product.descriptionJson).longDsc
												: filterSortDsc(product.translation.descriptionJson).longDsc,
									}}
								/>
							</StyledArticle>
						),
					};
				})}
			/>
			<style
				dangerouslySetInnerHTML={{
					__html: `
					.product_desc .ant-tabs-tab-active {
						border-top: 3px solid #e64545 !important;
					}
					.product_desc .ant-tabs-tab-btn {
						color: #000 !important;
					}
					.product_desc .ant-tabs-nav{
							background-color: #fafcff;
					}
		`,
				}}
			></style>
		</div>
	);
};

export default ProductDescription;

type dscList = {
	blocks: dscObj[];
};
type dscObj = {
	data: { text: string };
	type: string;
};
const filterSortDsc = (dsc: string) => {
	if(!dsc) return { sortDsc:'', longDsc:'' };
	const dscObj = JSON.parse(dsc) as dscList;
	let sortDsc = "";
	let longDsc = "";
	if (dscObj && dscObj.blocks.length > 0) {
		sortDsc = dscObj.blocks[1].data.text;
		longDsc = handlerInnerHtml(dscObj.blocks[0].data.text);
	}
	return { sortDsc, longDsc };
};

const handlerInnerHtml = (html: string): string => {
	if (!html) return html;
	const newHtml=replaceImgUrl(html)
	return newHtml.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&")
		.replace(/&quot;/g, '"')
		.replace(/&#8216;/g, "‘")
		.replace(/&#8217;/g, "’")
		.replace(/&#8211;/g, "–")
		.replace(/&nbsp;/g, " ");
};
